import React from 'react';
import { Badge as AntdBadge } from 'antd';

const Badge = ({
  count,
  showZero = true,
  dot = false,
  offset = [0, 0],
  color = '',
  className = '',
  children,
  overflowCount = Number.MAX_SAFE_INTEGER,
}) => {
  return (
    <AntdBadge
      count={count}
      showZero={showZero}
      color={color}
      children={children}
      dot={dot}
      offset={offset}
      className={className}
      overflowCount={overflowCount}
    />
  );
};

export default Badge;
